import { ConfigService, PaConfigKey } from '@ddt-web/config-layer';
import { LodashExtractor } from '@ddt-web/data-service';
import * as orderBy from 'lodash/orderBy';

import { FactMappingInterface } from '../../../models/fact-mapping.interface';
import { CategoryConstants } from '../../constants';
import { FactExtractor } from '../fact-extractor';

export const MORNINGSTAR_FACTS: { [factName: string]: FactMappingInterface } = {
	/**
	 * Total weight allocation to "Derivative Income", "Options Trading", and "Options-based" Morningstar categories
	 */
	derivativeAndOptionsAllocation: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			const derivativeOrOptionsHoldings = derivativeAndOptionsHoldings(children);
			return derivativeOrOptionsHoldings.length ? derivativeOrOptionsHoldings.reduce((acc, holding) => {
				return acc += holding.weight;
			}, 0) : 0;
		})
	},

	/**
	* Number of holdings that belong to "Derivative Income", "Options Trading", and "Options-based" Morningstar categories
	*/
	numberOfDerivativeAndOptions: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return derivativeAndOptionsHoldings(children).length;
		})
	},

	/**
	* Highest child allocation that belongs to "Municipal Bond" Morningstar category
	*/
	muniAllocation: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return highestMunicipalBondAllocation(children)?.weight ?? 0;
		})
	},

	/**
	* Highest child allocation ticket that belongs to "Municipal Bond" Morningstar category
	*/
	muniAllocationTicker: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return highestMunicipalBondAllocation(children)?.ticker ?? null;
		})
	}
};

function derivativeAndOptionsHoldings(children: any[]): any[] {
	const defaultDerivativesOrOptionsMorningstarCategoryList =
		ConfigService.instance.get(
			PaConfigKey.DERIVATIVES_AND_OPTIONS_MORNINGSTAR_CATEGORIES,
			CategoryConstants.defaultDerivativesOrOptionsMorningstarCategoryList);

	return children?.filter(
		child => defaultDerivativesOrOptionsMorningstarCategoryList.includes(child.funds?.morningstarCategory?.stringValue)
	) ?? [];
}

function highestMunicipalBondAllocation(children: any[]): any {
	const municipalBondMorningstarCategories =
		ConfigService.instance.get(
			PaConfigKey.MUNICIPAL_BOND_MORNINGSTAR_CATEGORIES,
			CategoryConstants.defaultMunicipalBondMorningstarCategoryList);

	const municipalBondsHoldings = children?.filter(
		child => municipalBondMorningstarCategories.includes(child.funds?.morningstarCategory?.stringValue)
	) ?? [];

	return orderBy(municipalBondsHoldings, ['weight', 'morningstarCategory'], ['desc', 'asc'])[0];
}
